import React from 'react';
import Slider from 'react-slick';
import CommonUtil from '../../../../utils/commonUtil';
import VerticalImageCarousel from './VerticalImageCarousel';
import CTA from '../../Content/MarketingSectionContainer/global/CTA';

const channel = CommonUtil.getChannel();
const isWap = channel === 'wap';

// Define arrows as components
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', clear: 'both' }}
      onClick={onClick}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height='32px'
        viewBox='0 -960 960 960'
        width='32px'
        fill='#434343'
      >
        <path d='M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z' />
      </svg>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, padding: '20px', display: 'block', clear: 'both' }}
      onClick={onClick}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height='32px'
        viewBox='0 -960 960 960'
        width='32px'
        fill='#434343'
      >
        <path d='M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z' />
      </svg>
    </div>
  );
};

const GenericCarousel = ({ component, state, ...rest }) => {
  const breakpoint_map = {
    desktop: 1024,
    tablet: 600,
    mobile: 480,
  };

  const sliderSettings = {
    responsive: component?.carousel_settings.responsive.map((r) => {
      const { device, ...rest } = r;
      return {
        breakpoint: breakpoint_map[r.device],
        settings: rest,
      };
    }),
  };

  const defaultSettings = sliderSettings.responsive.find(
    (r) => r.breakpoint === 1024,
  )?.settings;

  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    ...defaultSettings,
    ...sliderSettings,
  };

  if (component?.direction === 'Vertical') {
    const verticalSettings = {
      ...(component?.carousel_settings?.responsive?.length > 0
        ? { ...defaultSettings, initialSlide: null }
        : {}),
    };

    return (
      <VerticalImageCarousel
        component={component}
        state={state}
        verticalSettings={verticalSettings}
      />
    );
  }

  return (
    <div
      className={`section-wrapper section-padding horizontal-Carousel ${component?.carousel_display_template || 'carousel-template-generic'}`}
    >
      <div className='section-title'>
        {component?.title && <h5>{component?.title}</h5>}
        {component?.sub_title && (
          <p
            className={
              state?.user?.data?.result?.isLoggedIn &&
              component?.carousel_display_template !== 'carousel-template-3'
                ? 'logged-user-wap'
                : ''
            }
          >
            {component?.sub_title}
          </p>
        )}
      </div>
      {component?.description && (
        <p className='section5-text'>{component?.description}</p>
      )}
      <div
        className='wrapper'
        style={{ backgroundColor: component?.background_color }}
      >
        <div
          className={`carousel gift-icon-slider ${isWap ? '' : 'slick-initialized slick-slider'}`}
        >
          <Slider {...settings}>
            {component?.carousel_cards?.map((card, index) => (
              <div className='gift-wrap' key={index}>
                <CTA cta={{ ...card.cta }} isLink='true'>
                  <Card card={card} index={index} />
                </CTA>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export const Card = ({ card, index , svg = false }) => {
  return (
    <div
      className='card-bg-div'
      style={{ backgroundColor: `${card?.background_color}` }}
    >
      <div className='svg'>
        <img
          src={card?.banner_image?.url}
          alt={card?.banner_image_title}
          className='img-fluid'
          // for center aligned content, use true size image.
          style={{
            width:
              card.align === 'left' || card.align === 'right' ? '100%' : 'auto',
          }}
        />
      </div>
      {!svg && <div className='desc-section'>
        {card?.banner_image_title && (
          <h3 className='title' style={{ textAlign: card.align || 'left' }}>
            {card?.banner_image_title}
          </h3>
        )}
        {card?.banner_sub_title && (
          <div className='desc-container'>
            <p
              className='discription'
              style={{ textAlign: card.align || 'left' }}
            >
              {card?.banner_sub_title}
            </p>
          </div>
        )}
        {card?.banner_description && (
          <p
            className='discription'
            style={{ textAlign: card.align || 'left' }}
          >
            {card?.banner_description}
          </p>
        )}
      </div>}
    </div>
  );
};

export default GenericCarousel;
